module.exports = __webpack_public_path__ + "img/77352.992324f2.svg";